import { Route } from "react-router";
import { all_routes } from "../router/allRoute";

import Login from "../pages/auth/login/login";
import Register from "../pages/auth/register/register";
import VerifyOtp from "../pages/auth/verify-otp/verify-otp";
import Dashboard from "../pages/Dashboard/dashboard";

import PatientFamilyMember from "../pages/patient/patient-family-member/patient-family-member";

import Appointment from "../pages/appointment/appointment";
import AppointmentList from "../pages/appointmentList/appointmentList";
import DocterDashboard from "../pages/DocterDashboard/DocterDashboard";

import RescheduleAppointment from "../pages/RescheduleAppointment/RescheduleAppointment";
import MyVitalsReport from "../pages/Reports/MyVitalsReport";
import AiChatSummaryList from "../pages/aichatSummary/AiChatSummaryList";
import AiChatSummaryLogs from "../pages/aichatSummary/AiChartSummaryLogs";
import Reports from "../pages/Reports/Reports";
import MedicationList from "../pages/Medication/MedicationList";
import Medication from "../pages/Medication/Medication";
import profile from "../pages/profile/profile";
import Home from "../pages/Home/Home";
import CoinWallet from "../pages/CoinWallet/CoinWallet";
import CalendarModule from "../pages/Calendar/CalendarModule";
import MedicationDetail from "../pages/Medication/MedicationDetail";

const routes = all_routes;

export default function getRoutes() {
  return [
    {

      component: Login,
      route: Route,
      role: ["SuperAdmin", "User"],
    },
    {
      path: routes.login,
      component: Login,
      route: Route,
      role: ["SuperAdmin", "User"],
    },
    {
      path: routes.register,
      component: Register,
      route: Route,
      role: ["SuperAdmin", "User"],
    },
    {
      path: routes.dashboard,
      component: Dashboard,
      route: Route,
      role: ["SuperAdmin", "User"],
    },
    {
      path: routes.verifyOtp,
      component: VerifyOtp,
      route: Route,
      role: ["SuperAdmin", "User"],
    },

    {
      path: routes.PatientFamilyMember,
      component: PatientFamilyMember,
      route: Route,
      role: ["SuperAdmin", "User"],
    },
    {
      path: routes.Appointment,
      component: Appointment,
      route: Route,
      role: ["SuperAdmin", "User"],
    },
    {
      path: routes.appointmentList,
      component: AppointmentList,
      route: Route,
      role: ["SuperAdmin", "User"],
    },

    {
      path: routes.docterDashboard,
      component: DocterDashboard,
      route: Route,
      role: ["SuperAdmin", "User"],
    },
    {
      path: routes.rescheduleAppointment,
      component: RescheduleAppointment,
      route: Route,
      role: ["SuperAdmin", "User"],
    },

    {
      path: routes.myVitalsReport,
      component: MyVitalsReport,
      route: Route,
      role: ["SuperAdmin", "User"],
    },
    {
      path: routes.aiChatSummaryList,
      component: AiChatSummaryList,
      route: Route,
      role: ["SuperAdmin", "User"],
    },


    {
      path: routes.reports,
      component: Reports,
      route: Route,
      role: ["SuperAdmin", "User"],
    },

    {
      path: routes.medication,
      component: MedicationList,
      route: Route,
      role: ["SuperAdmin", "User"],
    },
    {
      path: routes.medicationDetail,
      component: MedicationDetail,
      route: Route,
      role: ["User"],
    },
    {
      path: routes.addMedication,
      component: Medication,
      route: Route,
      role: ["SuperAdmin", "User"],
    },


    {
      path: routes.aiChatSummaryLogsWithSession,
      component: AiChatSummaryLogs,
      route: Route,
      role: ["SuperAdmin", "User"],
    },

    {
      path: routes.patientProfile,
      component: profile,
      route: Route,
      role: ["SuperAdmin", "User"],
    },
    {
      path: "/",
      path: routes.home,
      component: Home,
      route: Route,
      role: ["SuperAdmin", "User"],
    },
    {
      path: routes.coinWallet,
      component: CoinWallet,
      route: Route,
      role: ["SuperAdmin", "User"],
    },
    {
      path: routes.calendar,
      component: CalendarModule,
      route: Route,
      role: ["SuperAdmin", "User"],
    },







    // Add more routes here as needed
  ];
}
